import ReactDOM from "react-dom";
import React, { useState } from "react";
import RouteSelector from "./routeSelector/routeSelector";
import Callout from "./scheduleCallout/callout";
import ScheduleTable from "./scheduleTable/scheduleTable";
import RouteData from "../../interfaces/routes/routeData";

function ScheduleMap() {
	const container = document.getElementById("schedule-map") as HTMLElement;
	const environment = process.env.NODE_ENV;
	const localDomain =
		environment === "development" ? "https://www.capmetro-local.com" : "";
	const timetableAPI = `${localDomain}/webapi/atis/timetable`;

	const showNotification = container.dataset.notification;
	const notificationTitle = container.dataset.notificationTitle;
	const notificationContent = container.dataset.notificationContent;
	const notificationClass = container.dataset.notificationClass;
	const footerNote = document.getElementById('schedule-footer-note');

	const [selectedRoute, updateSelectedRoute] = useState<string>('');
	const [scheduleData, updateScheduleData] = useState<any>();
	const [loadingStatus, setLoadingStatus] = useState<boolean>(false);

	const handleRouteClick = (e: React.SyntheticEvent) => {
		const target = e.target as HTMLElement;
		const route = target.dataset.route;
		if (route !== undefined) {
			updateSelectedRoute(route);
		}
	}

	const onRouteChange = (routeData: RouteData) => {
		const url = `${timetableAPI}/${routeData.RouteNumber}`;
		setLoadingStatus(true);
		// cant make calls to the api if not connected to the vpn
		// local development purposes only
		if (environment === 'development' || window.location.origin === 'https://www.capmetro-local.com') {
			const routeNumber = routeData.RouteNumber;
			try {
				const tableJson = require(`./demoData/routetimetable${routeNumber}.json`);
				setLoadingStatus(false);
				updateScheduleData(tableJson.Data);
				if (footerNote) {
					footerNote.hidden = false;
				}
			} catch (err) {
				const tableJson = require(`./demoData/routetimetable1.json`);
				setLoadingStatus(false);
				updateScheduleData(tableJson.Data);
			}
		} else {
			fetch(url)
			.then((response) => response.json())
			.then((data) => {
				if (data) {
						setLoadingStatus(false);
						updateScheduleData(data.Data);
						if (footerNote) {
							footerNote.hidden = false;
						}
					}
				})
				.catch((error) => {
					setLoadingStatus(false);
					console.error('Error retrieving timetable data:', error);
				});
		}
	};
	
	return ReactDOM.createPortal(
		<div className="schedule-map">
			<div className="schedule-map__section schedule-map__section--stripes py-5">
				<div className="schedule-map__container">

					<Callout type="mobile" target="schedule-callout-primary" />

					<Callout
						type="mobile"
						target="schedule-callout-secondary"
					/>
					<div className="schedule-map__content">
						<button type="button" className="schedule-map__service" onClick={handleRouteClick} data-route="550" aria-label="view rail service route info">Rail Service</button>
						<h2 className="schedule-map__heading">
							All Routes Selector
						</h2>
						<p className="schedule-map__label">
							Select or type in your individual route.
						</p>
						<RouteSelector
							onRouteChange={onRouteChange} selectedRoute={selectedRoute}
						></RouteSelector>
					</div>
					<div className="schedule-map__rail">
						<Callout type="desktop" target="schedule-callout-primary" />
						<Callout
							type="desktop"
							target="schedule-callout-secondary"
						/>
					</div>
				</div>
			</div>
			{
				showNotification === "True" &&
				<div className={`schedule-alert ${notificationClass}`}>
					<div className="schedule-alert__container">
						<h3 className="schedule-alert__heading">{notificationTitle}</h3>
						{
							notificationContent &&
							<div dangerouslySetInnerHTML={{ __html: notificationContent }} />
						}
					</div>
				</div>
			}
			<div className="schedule-map__section schedule-map__section--darkgray py-4">
				<div className="schedule-map__container">
					<h1 className="schedule-map__title">Routes by service type</h1>
					<div className="schedule-apps">
						<h2 className="schedule-apps__heading">App Download</h2>
						<a className="schedule-apps__link ios" href="https://itunes.apple.com/us/app/capmetro/id787315615?ls=1&amp;mt=8">
							<span className="schedule-apps__icon icon-AppleStore"></span>
							<span className="visually-hidden">ios app download</span>
						</a>
						<a className="schedule-apps__link android" href="https://play.google.com/store/apps/details?id=co.bytemark.cmta">
							<span className="schedule-apps__icon icon-PlayStore"></span>
							<span className="visually-hidden">android app download</span>
						</a>
					</div>
				</div>
			</div>
			<div className="visually-hidden" aria-live="polite">
				{
					loadingStatus ? <>Loading route table results.</> : ''
				}
			</div>
			{
				loadingStatus ? (
					<div className="schedule-map__loader"><div></div><div></div><div></div></div>
				)
				: ( scheduleData && (
					<div className="schedule-map__section py-5">
						<div className="schedule-map__container">
							<ScheduleTable scheduleData={scheduleData}></ScheduleTable>
						</div>
					</div>	
				)
				)
			}
		</div>,
		container
	);
}
export default ScheduleMap;
